export enum AddressType {
	CustomerPersonal = 0,
	CustomerInvoice = 1,
	CustomerDelivery = 2,
	OrderInvoice = 3,
	OrderDelivery = 4,
}
